import { persistStore, persistReducer } from "redux-persist";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage/session"; // Usa `sessionStorage` come storage
import userReducer from "../slice/userSlice";
import editUserReducer from "../slice/editUserSlice";
import editTagReducer from "../slice/editTagSlice";
import editOfficeReducer from "../slice/editOfficeSlice";
import editDoorReducer from "../slice/editDoorSlice";
import confirmModalReducer from "../slice/confirmModalSlice";
import showMOdalReducer from "../slice/showModalSlice";
import generalSettingReducer from "../slice/generalSettingSlice";


const persistConfig = {
    key: "root",
    storage,
    blacklist: ["confirmModal","editUser","editTag","editOffice","editDoor","showModal"], // Ignora specifici reducer
};

const reducers = combineReducers({
    user: userReducer,
    confirmModal:confirmModalReducer,
    editUser: editUserReducer,
    editTag: editTagReducer,
    editOffice: editOfficeReducer,
    editDoor: editDoorReducer,
    showModal: showMOdalReducer,
    generalSetting: generalSettingReducer
})

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: false, // Disabilita del tutto il controllo di serializzabilità
        }),
});

export const persistor = persistStore(store);
export default store;